'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactBootstrap = require('react-bootstrap');

var _reactBeautifulDnd = require('react-beautiful-dnd');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MediaBox = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(MediaBox, _Component);

  function MediaBox() {
    var _ref;

    var _temp, _this2, _ret;

    (0, _classCallCheck3.default)(this, MediaBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = MediaBox.__proto__ || (0, _getPrototypeOf2.default)(MediaBox)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
      counter: 0,
      dancingCount: 0,
      dragOver: false,
      interval: null,
      empty: true,
      visibleIndex: 0
    }, _this2.dragCounter = 0, _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(MediaBox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.images && this.props.images.length > 0) {
        this.showField();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.images.length <= this.state.visibleIndex) {
        this.setState({
          visibleIndex: 0
        });
      }
    }
  }, {
    key: 'setVisibleIndex',
    value: function setVisibleIndex(ev, visibleIndex) {
      ev.stopPropagation();

      this.setState({
        visibleIndex: visibleIndex,
        empty: false
      });
    }
  }, {
    key: 'dance',
    value: function dance(event) {
      var interval = this.state.interval;

      var _this = this;
      var _target = document.getElementById('buddy-dance');

      event.preventDefault();

      this.dragCounter++;

      if (!interval) {
        this.setState({
          dragOver: true,
          interval: setInterval(function () {
            _this.changeDanceClass(_target);
          }, 300)
        });
      }
    }
  }, {
    key: 'stopDancing',
    value: function stopDancing() {
      var interval = this.state.interval;


      this.dragCounter--;

      if (this.dragCounter === 0) {
        clearInterval(interval);
        document.getElementById('buddy-dance').className = 'icon-cg-buddy';
        this.setState({
          dancingCount: 0,
          dragOver: false,
          interval: null
        });
      }
    }
  }, {
    key: 'uploadDroppedImage',
    value: function uploadDroppedImage(event) {
      event.preventDefault();
      this.uploadTarget(event.dataTransfer);
    }
  }, {
    key: 'readURL',
    value: function readURL(input) {
      var polyglot = this.props.polyglot;


      var reader = new FileReader();

      if (input.files && input.files[0]) {
        if (input.files[0].size > 5000000) {
          alert(polyglot.t('mediaBox.pleaseUploadSmallerFile')); // eslint-disable-line no-alert
          return false;
        }

        reader.readAsDataURL(input.files[0]);
      }
    }
  }, {
    key: 'uploadTarget',
    value: function uploadTarget(target) {
      var _this3 = this;

      this.stopDancing();
      this.showField();
      if (this.readURL(target) !== false) {
        this.props.handleAddImage(target.files[0], function () {
          _this3.refs.mediaBoxPopover.show();
        });
      }
    }
  }, {
    key: 'openUploadDialog',
    value: function openUploadDialog() {
      document.getElementById('event-image-upload').click();
    }
  }, {
    key: 'uploadImage',
    value: function uploadImage(event) {
      event.preventDefault();
      this.uploadTarget(event.target);
    }
  }, {
    key: 'showField',
    value: function showField() {
      this.setState({
        empty: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          handleChangeImageCredits = _props.handleChangeImageCredits,
          handleChangeImagePosition = _props.handleChangeImagePosition,
          handleRemoveImage = _props.handleRemoveImage,
          images = _props.images,
          polyglot = _props.polyglot,
          title = _props.title;
      var _state = this.state,
          dragOver = _state.dragOver,
          empty = _state.empty,
          visibleIndex = _state.visibleIndex;


      var popoverContainer = this;
      var classes = (0, _classnames2.default)({
        'event-image-box': true,
        'event-image-box-hover': dragOver
      });

      return _react2.default.createElement(
        'div',
        { className: (empty ? 'dashed' : 'line') + '-box media-box' },
        _react2.default.createElement(
          _reactBootstrap.OverlayTrigger,
          {
            ref: 'mediaBoxPopover',
            trigger: 'click',
            placement: 'bottom',
            rootClose: true,
            container: popoverContainer,
            overlay: _react2.default.createElement(
              _reactBootstrap.Popover,
              {
                id: 'media-box-popover',
                className: 'media-box-popover'
              },
              _react2.default.createElement(
                'div',
                { className: 'container' + (images.length > 0 ? ' has-media' : '') },
                _react2.default.createElement(
                  _reactBeautifulDnd.DragDropContext,
                  { onDragEnd: handleChangeImagePosition },
                  _react2.default.createElement(
                    _reactBeautifulDnd.Droppable,
                    { droppableId: 'droppable' },
                    function (provided) {
                      return _react2.default.createElement(
                        'div',
                        { ref: provided.innerRef },
                        images.map(function (image, index) {
                          return _react2.default.createElement(
                            _reactBeautifulDnd.Draggable,
                            { key: image.id || image.filename, draggableId: image.id || image.filename, index: index },
                            function (provided) {
                              return (// eslint-disable-line no-shadow
                                _react2.default.createElement(
                                  'div',
                                  null,
                                  _react2.default.createElement(
                                    'div',
                                    (0, _extends3.default)({
                                      className: 'row result',
                                      ref: provided.innerRef
                                    }, provided.draggableProps),
                                    _react2.default.createElement(
                                      'div',
                                      { className: 'col-sm-1' },
                                      _react2.default.createElement(
                                        'span',
                                        (0, _extends3.default)({ className: 'btn btn-burger' }, provided.dragHandleProps),
                                        _react2.default.createElement('span', { className: 'icon-bar' }),
                                        _react2.default.createElement('span', { className: 'icon-bar' }),
                                        _react2.default.createElement('span', { className: 'icon-bar' })
                                      )
                                    ),
                                    _react2.default.createElement(
                                      'div',
                                      { className: 'col-sm-1' },
                                      _react2.default.createElement('img', { src: image.sizes.thumbnail || image.sizes.original, width: '100%', height: 'auto' })
                                    ),
                                    _react2.default.createElement(
                                      'div',
                                      { className: 'col-sm-9' },
                                      _react2.default.createElement(
                                        'label',
                                        null,
                                        polyglot.t('mediaBox.credits')
                                      ),
                                      _react2.default.createElement('input', {
                                        type: 'text',
                                        defaultValue: image.credits,
                                        onChange: function onChange(ev) {
                                          handleChangeImageCredits(index, ev.target.value);
                                        },
                                        className: 'form-control'
                                      })
                                    ),
                                    _react2.default.createElement(
                                      'div',
                                      { className: 'col-sm-1' },
                                      _react2.default.createElement('a', {
                                        className: 'col-md-1 result-delete',
                                        href: '#',
                                        onClick: function onClick() {
                                          handleRemoveImage(index);
                                        }
                                      })
                                    )
                                  ),
                                  provided.placeholder
                                )
                              );
                            }
                          );
                        })
                      );
                    }
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'add-button' },
                  _react2.default.createElement(
                    'button',
                    {
                      type: 'button',
                      className: 'btn btn-default btn-outline',
                      onClick: this.openUploadDialog.bind(this)
                    },
                    images.length > 0 ? polyglot.t('mediaBox.uploadAnotherImage') : polyglot.t('mediaBox.uploadAnImage')
                  )
                )
              )
            )
          },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement('input', {
              type: 'file',
              id: 'event-image-upload',
              name: 'image',
              onChange: this.uploadImage.bind(this)
            }),
            _react2.default.createElement(
              'div',
              {
                className: classes,
                onDragOver: function onDragOver(event) {
                  event.preventDefault();
                },
                onDragEnter: this.dance.bind(this),
                onDragLeave: this.stopDancing.bind(this),
                onDrop: this.uploadDroppedImage.bind(this)
              },
              (empty || dragOver) && _react2.default.createElement(
                'div',
                { className: 'event-image-placeholder' },
                _react2.default.createElement('span', { id: 'buddy-dance', className: 'icon-cg-buddy' })
              ),
              !(empty || dragOver) && _react2.default.createElement(
                'div',
                { className: 'medias' },
                images.map(function (image, index) {
                  return _react2.default.createElement(
                    'span',
                    { key: image.id || image.filename, className: index === visibleIndex ? 'active' : '' },
                    _react2.default.createElement('img', { src: image.sizes.medium || image.sizes.original })
                  );
                }),
                _react2.default.createElement(
                  'div',
                  { className: 'media-navigation' },
                  images.map(function (image, index) {
                    return _react2.default.createElement(
                      'span',
                      {
                        className: 'media-navigation-button',
                        key: image.id || image.filename,
                        onClick: function onClick(ev) {
                          _this4.setVisibleIndex(ev, index);
                        }
                      },
                      index === visibleIndex ? '▣' : '▢'
                    );
                  })
                )
              ),
              _react2.default.createElement(
                'label',
                { className: 'box-title' },
                title || polyglot.t('mediaBox.title')
              )
            )
          )
        )
      );
    }
  }]);
  return MediaBox;
}(_react.Component), _class.propTypes = {
  handleAddImage: _propTypes2.default.func.isRequired,
  handleChangeImageCredits: _propTypes2.default.func.isRequired,
  handleChangeImagePosition: _propTypes2.default.func.isRequired,
  handleRemoveImage: _propTypes2.default.func.isRequired,
  images: _propTypes2.default.array,
  loading: _propTypes2.default.bool,
  polyglot: _propTypes2.default.object.isRequired,
  title: _propTypes2.default.string
}, _class.defaultProps = {
  images: []
}, _temp2);
exports.default = MediaBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/MediaBox.js
// module id = 2217
// module chunks = 0